import { RefObject, useCallback, useEffect, useState } from 'react';

export type VideoVirtualProgressProps = {
  width: number;
  progressRef: RefObject<HTMLDivElement>;
  parentWidth: number;
};

export const VideoVirtualProgress = (p: VideoVirtualProgressProps) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseUp = useCallback(() => setIsDragging(false), []);

  useEffect(() => {
    if (isDragging) {
      const handleMouseMove = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();

        if (p.progressRef?.current?.parentElement) {
          const { left } =
            p.progressRef.current.parentElement.getBoundingClientRect();
          const x = event.clientX - left;
          const percentage = (x / p.parentWidth) * 100;
          const percentageBounded = Math.max(0, Math.min(percentage, 100));

          p.progressRef.current.style.left = `${percentageBounded}%`;
        }
      };

      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging, p.parentWidth, p.progressRef, handleMouseUp]);

  return (
    <div
      ref={p.progressRef}
      onMouseUp={handleMouseUp}
      onMouseDown={() => setIsDragging(true)}
      style={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: `${p.width}px`,
        height: '100%',
        backgroundColor: 'white',
        border: 'solid 1px grey',
        borderRadius: '5px',
        cursor: 'pointer',
      }}
    />
  );
};
